import React, { useState } from 'react'
import { format } from 'date-fns'
import fr from 'date-fns/locale/fr'
import addDays from 'date-fns/addDays'

const usePlanning = (initialState) => { 
    const [valuesPlanning, setValuesPlanning] = useState(initialState) 

    // CONVERTE TIME TO HOURS 
    const _converteTimeToHours = (h) => {
        let hours = ''
        hours = h * 15
        var a = hours
        var b = 60 
        var quo = Math.floor(a/b)
        let quoFinal = quo < 10 ? '0'+quo : quo
        var rem = a%b
        let remFinal = rem === 0 ? '00' : rem
        let final = quoFinal+':'+remFinal
        return final
    }

    const _converteTimeToSingleHour = (h) => {
        let hours = ''
        hours = h * 15
        var a = hours
        var b = 60 
        var quo = Math.floor(a/b)
        let quoFinal = quo < 10 ? '0'+quo : quo
        var rem = a%b
        let remFinal = rem === 0 ? '00' : rem
        let final = quoFinal
        return final
    }

    // CONVERT TIME TO MINUTES
    const _converteTimeMinutes = (h) => {
        let hours = ''
        hours = h * 15
        var a = hours
        var b = 60 
        var quo = Math.floor(a/b)
        let quoFinal = quo < 10 ? '0'+quo : quo
        var rem = a%b
        let remFinal = rem === 0 ? '00' : rem
        let final = remFinal
        return final
    }

    // CONVERTE HOURS TO TIME
    const _convertHoursToTime = (h, m) => {
        let minutesInt = parseInt(m)
        let min = ''
        if (minutesInt < 15) min = 0
        if (minutesInt > 14 && minutesInt < 30) min = 15
        if (minutesInt > 29 && minutesInt < 45) min = 30
        if (minutesInt > 44) min = 45
        let sum = ''
        return sum = ((parseInt(h,10)*60)+(min))/15
    }
  
    // CONVERTE TIME
    const _converteTime = (open, hours, minutes) => {
        let minutesInt = parseInt(minutes,10)
        let min = ''
        if (minutesInt < 15) min = 0
        if (minutesInt > 14 && minutesInt < 30) min = 15
        if (minutesInt > 29 && minutesInt < 45) min = 30
        if (minutesInt > 44) min = 45
        let sum = ''
        if (open === true) {
            return sum = ((parseInt(hours,10)*60)+(min))/15
        } else { return null}
    }
 
    // DISPLAY HOURS
    const _displayHours = () => {
        const array = []
        for (let i = 0; i < 96; i++) {
            array.push(i)
        }
        return array
    }

    // DISPLAY 60 DAYS
    const _display60Days = () => {
        const array = []
        const m = 0

        for (let i = 0; i < 60; i++) {

            const addDay = addDays(new Date(Date.now()), i)
            const day = format(new Date(addDay), 'EEEE', {locale:fr})
            const date = format(new Date(addDay), 'MM/dd/yyyy')
            const dateShow = format(new Date(addDay), 'EEEE dd MMMM', {locale:fr})
            const dateInt = format(new Date(addDay), 'ddMMyyyy')

            array.push({ date:date, day:day, dateShow:dateShow, dateInt:dateInt })
        }

        return array 
    }

    // CHOICE STAFF
    const _choiceStaff = (idStaff, surnameStaff, nameStaff) => {
        setValuesPlanning(prevValues => ({
            ...prevValues,
            idStaff:idStaff,
            surnameStaff:surnameStaff,
            nameStaff:nameStaff 
        }))
    } 
 
    // DISPLAY STAFF
    const _displayStaff = (day,date,staff,datesOff) => {
        console.log('usePlanning _displayStaff','jour:',day,'date',date,'staff',staff,'dateoff',datesOff,'idStaff',valuesPlanning.idStaff)
        const array = []
        // STAFF 
        staff.filter(valuesPlanning.idStaff ? st => st.id === valuesPlanning.idStaff : st => st).map(st => (

            // LE JOUR EST-IL OUVERT 
            st[day+'open'] === true && [st[day+'amOpen'] === true || st[day+'pmOpen'] === true] &&

            // EST-CE UN JOUR DE VACANCES
            datesOff.filter(d => d.idStaff === st.id && date >= d.startDate && date <= d.endDate ).length === 0 &&

            array.push({
                idStaff:st.id,
                surnameStaff:st.surnameStaff,
                nameStaff:st.nameStaff,
                amStart:_converteTime(st[day+'amOpen'],st[day+'hoursAMStart'],st[day+'minutesAMStart']),
                amEnd:_converteTime(st[day+'amOpen'],st[day+'hoursAMEnd'],st[day+'minutesAMEnd']),
                pmStart:_converteTime(st[day+'pmOpen'],st[day+'hoursPMStart'],st[day+'minutesPMStart']), 
                pmEnd:_converteTime(st[day+'pmOpen'],st[day+'hoursPMEnd'],st[day+'minutesPMEnd']),
            })

        ))
        return array
    }
  
    // DELETE VALUES PLANNING
    const _deleteState = () => {
        setValuesPlanning('')
    }

    // AFFICHER LE NOMBRE DE JOURS EN FONCTION DU NOMBRE DE SEMAINE DE L'ÉQUIPIER // DISPLAY DAYS WITH STAFF NBR WEEK 
    const _compareDay = (nbrWeeks) => { 
        const date = new Date()
        date.setDate(date.getDate() + nbrWeeks*7)
        const dateString = format(new Date(date), 'MM/dd/yyyy')
        return dateString
    }

    // FILTRER LES HEURES D'OUVERTURE EN FONCTION DU PLANNING DE L'EQUIPIER // FILTER HOURS VS STAFF HOURS PLANNING
    const _compareHours = (h,hams,mams,hame,mame,hpms,mpms,hpme,mpme) => {
        if ((_convertHoursToTime(hams,mams) <= h && h < _convertHoursToTime(hame,mame)) || (_convertHoursToTime(hpms,mpms) <= h && h < _convertHoursToTime(hpme,mpme))) {
            return true
        }
    }

    // SI AUJOURD'HUI AFFICHER SEULEMENT LES HEURES DISPONIBLES // IS DAY === CURRENT DAY DISPLAY ONLY HOURS AVAILABLE
    const _compareCurrentDayHours = (date,h) => {
        const currentDate = format(new Date(), 'MM/dd/yyyy')
        const currentHour = _convertHoursToTime(format(new Date(), 'k'),format(new Date(), 'm'))
        if (date === currentDate) {
            if (h > currentHour) {
                return currentHour 
            }
        } else return null
    }

    const _compareBooking = (booking,date, h, id) => {
        const ifBooking = booking.filter(b => b.date === date && b.hours === h && b.idStaff === id).length
        if (ifBooking > 0) {
            return true
        }
    }

    return { 
        _displayHours,
         _converteTimeToHours, 
         _converteTimeToSingleHour,
         _converteTimeMinutes,
         _convertHoursToTime, 
         _display60Days, 
         _choiceStaff, 
         _converteTime, 
         _displayStaff, 
         _deleteState, 
         _compareDay,
         _compareHours,
         _compareCurrentDayHours,
         _compareBooking,
         valuesPlanning 
    }
} 

export default usePlanning









